import * as React from "react";
import {
  Share,
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Dimensions,
  Linking,
  ScrollView,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../components/GlobalStyles";
import FooterBarWide from "../components/footerBarWide";
import MenuBar from "../components/headers/MenuBar";
import StatusBar from "../components/headers/StatusBar";
import { useSelector } from "react-redux";
import QRCode from "react-qr-code";
import GenericButton from "../components/GenericButton.js";
import Colors from "../utilities/Color.js";

const BGimage = require("../assets/images/invite/referral_Image.png");

function ShareMessageDevice(user) {
  (messageBody =
    user.subscriberDetails.givenName +
    ` suggests you join Aura today! 
    
Discover Aura, the unrivalled Australian cash back rewards platform. Get real money back every time you shop, online or in-store, with over 1,000 partner retailers. From Shell Coles Express to Booking.com, The Iconic, and beyond, we’ve got you covered!

Sign up for free using this referral link: https://app.aura.club/ref/` + user.subscriberDetails.referFriendId +
    `
Referral code: ` +
    user.subscriberDetails.referFriendId +

    `

Make your first purchase, and both you and  ` +
    user.subscriberDetails.givenName +
    ` will be rewarded $5 each! 
    
Safety and security are paramount to us. Verify this communication with the referring party or reach out to Aura directly at https://aura.club`),

    (messageTitle = "Join Aura today!"),
    Share.share({
      message: messageBody,
      title: messageTitle,
      subject: messageTitle,
    });
}

function ShareMessageWeb(user) {
  var messageBody =
    user.subscriberDetails.givenName +
    ` suggests you join Aura today! %0D %0DDiscover Aura, the unrivalled Australian cash back rewards platform. Get real money back every time you shop, online or in-store, with over 1,000 partner retailers. From Shell Coles Express to Booking.com, The Iconic, and beyond, we’ve got you covered!%0D %0DSign up for free using this referral link: https://app.aura.club/ref/` +
    user.subscriberDetails.referFriendId +
    ` %0DReferral code: ` +
    user.subscriberDetails.referFriendId +
    ` %0D %0DMake your first purchase, and both you and ` +
    user.subscriberDetails.givenName +
    ` will be rewarded $5 each! %0D %0DSafety and security are paramount to us. Verify this communication with the referring party or reach out to Aura directly at https://aura.club/ ` +
    ` %0D %0D`;

  var messageTitle = "Join Aura today!";

  var webMessage = "mailto:?subject=" + messageTitle + "&body=" + messageBody;

  Linking.openURL(webMessage);
}

export default function InviteScreen() {
  const user = useSelector((state) => state.user.userData);
  const navigation = useNavigation();
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerW}>
      <ScrollView style={styles.scrollView}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={[GlobalStyles.headerTextYellow]}>
                <Text style={styles.headingStyleQR}>My QR Code</Text>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="B" />
            <View style={GlobalStyles.headerContainerWKL}>
              <View style={GlobalStyles.headerText}>
                <Text style={GlobalStyles.headingStyle}>My QR Code</Text>
              </View>
            </View>
          </View>
        )}
        <View style={styles.bodyContainerFull}>
          <View style={styles.backgroundContainer}>
            <QRCode
              size={160}
              style={{ height: "auto", maxWidth: "160", width: "160" }}
              value={"https://app.aura.club/ref/" + user.subscriberDetails.referFriendId}
              viewBox={`0 0 256 256`}
            />
            <Text style={styles.refIDStyle}>
              {user.subscriberDetails.referFriendId}
            </Text>
            <Text style={styles.subheaderStyle}>
              Show or send this QR code to refer friends and both be rewarded with $5! Once your invitee has made their first purchase, $5 will be added to both accounts.
            </Text>
            <View>
              {Platform.OS !== "web" ? (
                <View style={styles.hyperLinkBox}>
                  <TouchableOpacity
                    style={GlobalStyles.linkStyleTight}
                    activeOpacity={0.5}
                    onPress={() =>
                      Linking.openURL("https://aura.club/terms-and-conditions/")
                    }
                  >
                    <Text style={styles.hyperLinkShopInfo}>Referral Terms</Text>
                  </TouchableOpacity>
                </View>
              ) : (
                <View style={styles.hyperLinkBox}>
                  <TouchableOpacity
                    style={GlobalStyles.linkStyleTight}
                    activeOpacity={0.5}
                    onPress={() =>
                      window.open(
                        "https://aura.club/terms-and-conditions/",
                        "_blank"
                      )
                    }
                  >
                    <Text style={styles.hyperLinkShopInfo}>Referral Terms</Text>
                  </TouchableOpacity>
                </View>
              )}
            </View>
          </View>
          <View style={styles.yellowView}>
            <View
              style={[win.width > 765 ? styles.containerW : styles.containerC]}
            >
              {Platform.OS === "web" ? (
                // This commented part can be removed in 22/10/23 
                // <TouchableOpacity
                //   style={styles.SubmitButtonStyle}
                //   onPress={() => ShareMessageWeb(user)}
                // >
                //   <View style={styles.makeRow}>
                //     <Text style={styles.TextStyle}>SHARE YOUR INVITE CODE</Text>
                //   </View>
                // </TouchableOpacity>
                <GenericButton
                  buttonText='SHARE YOUR INVITE CODE'
                  buttonColor={Colors.WHITE}
                  onPress={() => ShareMessageWeb(user)}
                />
              ) : (
                //  This commented part can be removed in 22/10/23 
                // <TouchableOpacity
                //   style={styles.SubmitButtonStyle}
                //   onPress={() => ShareMessageDevice(user)}
                // >
                //   <View style={styles.makeRow}>
                //     <Text style={styles.TextStyle}>SHARE YOUR INVITE CODE</Text>
                //   </View>
                // </TouchableOpacity>
                <GenericButton
                  buttonText='SHARE YOUR INVITE CODE'
                  buttonColor={Colors.WHITE}
                  onPress={() => ShareMessageDevice(user)}
                />
              )}
            </View>
            <Image style={styles.backgroundImage} source={BGimage} />
          </View>
        </View>
        <View style={GlobalStyles.webFooter}>
          {win.width > 768 ? <FooterBarWide /> : null}
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  backgroundImage: {
    flex: 1,
    width: 300,
    height: 300,
    resizeMode: "contain",
    paddingBottom: 20,
  },
  headingStyleQR: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "left",
    marginBottom: 35,
    color: "#333333",
  },
  backgroundContainer: {
    width: "100%",
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 20,
    alignItems: "center",
  },
  hyperLinkShopInfo: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    color: "#A8A1AC",
  },
  hyperLinkBox: {
    paddingTop: 15,
  },
  bodyContainerFull: {
    flex: 1,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5,
  },
  spacerView: {
    flex: 15,
  },
  containerW: {
    paddingTop: 20,
    alignSelf: "center",
    width: "70%",
  },
  containerC: {
    paddingTop: 20,
    alignSelf: "center",
    width: "100%",
  },
  makeRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },

  iconStyle: {
    paddingLeft: 10,
  },
  yellowView: {
    backgroundColor: "#FFC72C",
    color: "#FFFF",
    fontSize: 12,
    textAlign: "center",
    marginTop: 0,
    marginBottom: 0,
    height: 380,
    justifyContent: "flex-start",
    borderTopLeftRadius: 60,
    alignItems: "center",
  },
  blueView: {
    backgroundColor: "#4EBDEF",
    height: 190,
    borderTopLeftRadius: 100,
  },
  logoText: {
    color: "#FFFF",
    fontSize: 12,
    textAlign: "center",
    marginTop: 30,
  },
  inviteButtonStyle: {
    marginTop: 20,
    marginLeft: 70,
    marginRight: 70,
    marginBottom: 20,
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: "#FFFF",
    borderRadius: 20,
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },
  // This commented part can be removed in 22/10/23  
  // TextStyle: {
  //   color: "#132132",
  //   textAlign: "center",
  //   fontFamily: "montserrat-semibold",
  //   fontSize: 14,
  // },
  // This commented part can be removed in 22/10/23  
  // SubmitButtonStyle: {
  //   marginTop: 15,
  //   marginBottom: 5,
  //   paddingTop: 15,
  //   paddingBottom: 15,
  //   paddingLeft: 45,
  //   paddingRight: 45,
  //   backgroundColor: "#FFFF",
  //   borderRadius: 30,
  //   textAlign: "center",
  //   fontFamily: "montserrat-bold",
  //   fontSize: 12,
  //   alignSelf: "center",
  // },
  subheaderStyle: {
    fontFamily: "montserrat-medium",
    fontSize: 14,
    color: "#000000",
    textAlign: "center",
    marginTop: 40,
    maxWidth: 330,
  },
  refIDStyle: {
    fontFamily: "montserrat-semibold",
    fontSize: 16,
    color: "#000000",
    textAlign: "center",
    marginTop: 22,
    letterSpacing: 3,
  },
  headerContainerInvite: {
    height: 100,
    paddingRight: 20,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 80,
    borderBottomColor: "#dddddd",
    borderBottomWidth: 1,
    borderLeftColor: "#dddddd",
    borderLeftWidth: 1,
  },
});
